import axios from 'axios';                //  ← NEW

/* expose the Strapi API base */
const viteVar =
  typeof import.meta !== "undefined" &&
  import.meta.env &&
  import.meta.env.VITE_STRAPI_API;

const craVar = process.env.REACT_APP_STRAPI_API;

export const API_BASE =
  viteVar || craVar || "https://twinframe-strapi.onrender.com/api";

/* convert media path → full URL */
export const mediaUrl = (p = "") =>
  p?.startsWith("http") ? p : API_BASE.replace(/\/api$/, "") + p;

const viewKey = (documentId) => `viewed-news:${documentId}`;

/**
 * Bump view counter once per browser tab session (stops F5 spam).
 * Returns { skipped: true } if this session already counted the post.
 */
export const hitView = async (documentId) => {
  if (!documentId) return { skipped: true };

  try {
    if (sessionStorage.getItem(viewKey(documentId))) {
      return { skipped: true };
    }
    // claim immediately so Strict Mode / double-mount can't double-hit
    sessionStorage.setItem(viewKey(documentId), "1");
  } catch {
    /* private mode / blocked storage — still attempt the POST */
  }

  await axios.post(`${API_BASE}/news-items/${documentId}/view`);
  return { skipped: false };
};
